import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const raisedClaimCove = async (data: object) => {
  return axios.put(endpoints.claimRaisedCove, data)
}

export const useRaisedClaimCove = () => {
  const queryClient = useQueryClient()
  return useMutation(raisedClaimCove, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.CoveLisiting, ApiKey.list])
    },
  })
}
